<template>
  <div anchor-app-extra>
    <vue-snotify></vue-snotify>
    <privacy></privacy>
    <anchor-popup style="z-index: 204 !important;"></anchor-popup>

    <!--loader-->
    <v-overlay :value="loading" :style="loadingStyle">
      <v-progress-circular indeterminate size="80"></v-progress-circular>
    </v-overlay>

    <bottomNavigation></bottomNavigation>
    <bottomSheet></bottomSheet>
  </div>
</template>

<script lang="babel" type="text/babel">
import Vue from 'vue'
import AnchorPopup from 'plugins/anchorPopup/installer.js'
import Snotify from 'vue-snotify'
Vue.use(Snotify, {
  toast: { timeout: 5000, titleMaxLength: 32 },
})
export default {
  data: () => ({
    hasInit: false,
  }),
  created() {
    Vue.use(AnchorPopup, this.anchorPopupDefaultConfig)
    this.init()
  },
  methods: {
    async init() {
      this.hasInit = false

      const { default: VueClipboard } = await import(
        /* webpackChunkName: "vue-clipboard2" */
        /* webpackPrefetch: true */
        'vue-clipboard2'
      )
      Vue.use(VueClipboard)

      setTimeout(() => {
        this.hasInit = true
      }, 1000)
    },
  },
  computed: {
    loadingStyle() {
      return {
        zIndex: 999999999,
      }
    },
    anchorPopupDefaultConfig() {
      return {
        width: '350',
        applyLabel: this.i18n('action.apply'),
        closeLabel: this.i18n('action.close'),
      }
    },
    loading() {
      return this.$store.getters['base/loading']
    },
    language() {
      return this.$store.getters['locale/language']
    }
  },
  watch: {
    language() {
      this.$apopup.init(this.anchorPopupDefaultConfig)
    },
  },
  components: {
    privacy: () => import('appExtra/privacy'),
    bottomSheet: () => import(
      /* webpackChunkName: "bottomSheet" */
      /* webpackPrefetch: true */
      'appExtra/bottomSheet.vue'
    ),
    bottomNavigation: () => import(
      /* webpackChunkName: "bottomNavigation" */
      /* webpackPrefetch: true */
      'appExtra/bottomNavigation.vue'
    ),
  },
}
</script>

<style lang="sass" type="text/sass">
@import '~vue-snotify/styles/material'

// 處理tinymce在vuetify dialog無法啟用tinymce dialog的問題
div[anchor-bottom-sheet]
  div[role="document"].v-dialog__content
    z-index: 203 !important
</style>